import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import { Toggle } from 'components/Controls';
// Utilities
import { isRequired } from 'utilities/validation';
import ImageUpload from 'components/ImageUpload';
import MediaFormats from 'types/MediaFormats';

const CountdownForm:FC = () => {
  const { t } = useTranslation();

  const { control, watch, formState: { errors } } = useFormContext();

  const isCountdownPageEnabled = watch('countdownPage.enabled', false);

  return (
    <div className="w-full flex flex-wrap -mx-6 -y-4 px-6 pb-3">
      <div className="w-full landscape:w-1/2 tablet:w-full laptop:w-7/12 px-6">
        <div className="flex items-center mt-2 mb-4">
          <span className="block text-white text-base font-semibold mr-3">{t('pages.quizForm.enabledCountdownLabel')}</span>
          <Controller
            control={control} name="countdownPage.enabled"
            render={({ field: { onChange, value } }) => (
              <Toggle
                id="countdownPageEnabled"
                checked={value}
                onChange={onChange}
              />
            )}
          />
        </div>
        <span className="block text-gray-400 text-sm font-light leading-5 mb-2">
          {t('form.helperText.enterYourOwnText')}
        </span>
        <MultiLanguageTextField
          rules={{ required: isCountdownPageEnabled ? isRequired : false }}
          name="countdownPage.title"
          label={t('labels.title')}
          required={isCountdownPageEnabled}
          error={Boolean(errors.countdownPage?.title)}
          errorText={isCountdownPageEnabled ? errors.countdownPage?.title?.message : ''}
          className="mb-4"
          disabled={!isCountdownPageEnabled}
        />
        <MultiLanguageTextField
          name="countdownPage.text1"
          label={t('pages.quizForm.textWithIndex', { index: 1 })}
          className="mb-4"
          disabled={!isCountdownPageEnabled}
        />
        <MultiLanguageTextField
          name="countdownPage.text2"
          label={t('pages.quizForm.textWithIndex', { index: 2 })}
          className="mb-4"
          disabled={!isCountdownPageEnabled}
        />
      </div>
      <div
        className="
          w-full landscape:w-1/2 tablet:w-full laptop:w-5/12
          landscape:border-l tablet:border-l-0 laptop:border-l
          px-6
        "
        style={{
          borderColor: 'rgba(255,255,255,0.2)'
        }}
      >
        <Controller
          control={control}
          name="countdownPage.image"
          render={({ field }) => (
            <ImageUpload
              {...field}
              format={MediaFormats.Question}
              label="labels.image"
            />
          )}
        />
      </div>
    </div>
  )
}

export default CountdownForm;
